import React from 'react'
import SVG from 'react-inlinesvg'
import SvgSprite from '@sm360/inventory-vdp-360/dist/assets/svg-sprite.svg'

import { runtimeConfig } from '../config/runtimeConfig'

import VdpView from '../../views/vdp/Vdp.view'

const VdpSSR = () => {
    React.useEffect(() => {
        if (typeof window === 'undefined') {
            global.window = {}
        }
    }, [])
    const svgBaseUrl = runtimeConfig.REACT_APP_ASSETS_PATH ? `${runtimeConfig.REACT_APP_ASSETS_PATH}/inventory-vdp-360` : ''
    return (
        <>
            <SVG
                src={`${svgBaseUrl}${SvgSprite}`}
                style={{ display: 'none' }}
                onError={(error) => console.log('svg error', error)}
            />

            <VdpView />
        </>
    )
}

export default VdpSSR
